module.exports = __webpack_public_path__ + "static/media/icon_azure-synapse.d17df7ae.svg";